export default __webpack_public_path__ + "static/media/noSavedJobsHeart.d80b5e66.png";